import * as React from 'react';

import { observer } from 'mobx-react';

import * as classnames from 'classnames';

import { IPasswordCriteria } from '~domain/entities/Config';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { PasswordCriteriaViewController } from '~views/components/PasswordCriteriaViewController';

const componentName = 'password-criteria';
const titleClassName = classes(`iam-${componentName}-title`);
const itemWrapperClassName = classes(`iam-${componentName}-item-wrapper`);
const itemClassName = classes(`iam-${componentName}-item`);

export const PasswordCriteria = observer((props: IPasswordCriteria) => {
    const passwordCriteriaViewController = diContainer.get(
        serviceNames.passwordCriteriaViewController
    ) as PasswordCriteriaViewController;

    passwordCriteriaViewController.loaded(props);

    const { inputLabel } = props;

    const {
        data: { criteriaData, isShown }
    } = passwordCriteriaViewController;

    return (
        <>
            {isShown && (
                <div>
                    {inputLabel && <div className={titleClassName}>{inputLabel}</div>}
                    <div>
                        <ul className={itemWrapperClassName}>
                            {criteriaData.map((item) => {
                                return (
                                    <li
                                        key={item.name}
                                        className={classnames(
                                            itemClassName,
                                            `elc-iam-${componentName}-${item.name}`,
                                            item.isMatched ? 'matched' : 'unmatched'
                                        )}
                                    >
                                        {item.inputLabel}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
});
